var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#004A96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8465 60.1798L32.5132 50.8465C32.2691 50.5995 31.9784 50.4033 31.658 50.2695C31.3376 50.1356 30.9938 50.0667 30.6465 50.0667C30.2992 50.0667 29.9554 50.1356 29.635 50.2695C29.3146 50.4033 29.0239 50.5995 28.7798 50.8465C28.5328 51.0906 28.3367 51.3812 28.2028 51.7017C28.0689 52.0221 28 52.3659 28 52.7132C28 53.0604 28.0689 53.4043 28.2028 53.7247C28.3367 54.0451 28.5328 54.3358 28.7798 54.5798L39.9532 65.7532C40.9932 66.7932 42.6732 66.7932 43.7132 65.7532L71.9798 37.5132C72.2269 37.2691 72.423 36.9784 72.5569 36.658C72.6908 36.3376 72.7597 35.9938 72.7597 35.6465C72.7597 35.2992 72.6908 34.9554 72.5569 34.635C72.423 34.3146 72.2269 34.0239 71.9798 33.7798C71.7358 33.5328 71.4451 33.3367 71.1247 33.2028C70.8043 33.0689 70.4604 33 70.1132 33C69.7659 33 69.4221 33.0689 69.1017 33.2028C68.7812 33.3367 68.4906 33.5328 68.2465 33.7798L41.8465 60.1798Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.8c08bacd.svg";
export { ForwardRef as ReactComponent };